type ApiMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export type ApiResult<T> = {
    success: boolean;
    message: string;
    data?: T;
};

export const hasEmail = (email: string) => email.trim().length > 0;

export const hasBaseUrl = (url: string) => url.trim().length > 0;

export async function apiRequest<T>({
    url,
    method,
    body,
    failureMessage,
}: {
    url: string;
    method: ApiMethod;
    body?: unknown;
    failureMessage: string;
}): Promise<ApiResult<T>> {
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: body ? JSON.stringify(body) : undefined,
        });

        if (!response?.ok) {
            return { success: false, message: failureMessage };
        }

        const data = await response.json();

        if (!data || data.status !== 200) {
            return { success: false, message: data?.message ? `${failureMessage}: ${data.message}` : failureMessage };
        }

        return { success: true, message: data.message || 'Success', data: data as T };
    } catch (error) {
        return { success: false, message: `${failureMessage}: ${error}` };
    }
}
